import * as React from 'react';
import Tooltip from '@mui/joy/Tooltip';
import { useColorScheme } from '@mui/joy/styles';
import IconButton from '@mui/joy/IconButton';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeIcon from '@mui/icons-material/LightMode';
import { resolveColorMode } from '../theme/colorMode';

export default function ColorSchemeToggle(props) {
  const { onClick, sx, tooltipPlacement = 'top', ...other } = props;
  const { mode, systemMode, setMode } = useColorScheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  const resolvedMode = resolveColorMode(mode, systemMode);
  const nextMode = resolvedMode === 'dark' ? 'light' : 'dark';
  const actionLabel = `Switch to ${nextMode} mode`;

  const handleClick = (event) => {
    setMode(nextMode);
    onClick?.(event);
  };

  const button = (
    <IconButton
      data-screenshot="toggle-mode"
      data-testid="color-scheme-toggle"
      size="sm"
      variant="outlined"
      color="neutral"
      aria-label={actionLabel}
      {...other}
      onClick={mounted ? handleClick : undefined}
      sx={[
        resolvedMode === 'dark'
          ? { '& > *:first-of-type': { display: 'none' } }
          : { '& > *:first-of-type': { display: 'initial' } },
        resolvedMode === 'light'
          ? { '& > *:last-of-type': { display: 'none' } }
          : { '& > *:last-of-type': { display: 'initial' } },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      disabled={!mounted}
    >
      <DarkModeRoundedIcon />
      <LightModeIcon />
    </IconButton>
  );

  return (
    <Tooltip title={actionLabel} variant="solid" placement={tooltipPlacement}>
      <span>{button}</span>
    </Tooltip>
  );
}
